import {getDevice} from "./lib.js";
// Loader
export default class InitState extends Phaser.Scene {
  // Init
  constructor () {
    super({ key: 'InitState', active: false });
  }
  
  // Preload assets
  preload () {
   // this.load.baseURL = 
   this.loadcnt = 0
   this.loadmax = 44;
   this.load.baseURL = GameConfig.url;//
   //     (window.location + '').replace(/[^\/]*$/g, '') +
   //     document.querySelector('script[src$="js/Main.js"]')
   //     .getAttribute('src')
   //     .replace('js/Main.js',"");
    
    // Background
    //this.add.image(550 / 2, 400 / 2, 'img_load');
    
    var progressBox = this.add.graphics();
    progressBox.fillStyle(0xAAAAAA, 0.8);
    progressBox.fillRect(215, 270, 110, 10);
    
    var progressBar = this.add.graphics();
    
    var width = this.cameras.main.width;
    var height = this.cameras.main.height;

    var assetText = this.make.text({
        x: width / 2,
        y: height / 2 + 100,
        text: '',
        style: {
          font: '12px monospace',
          fill: '#000000'
        }
    });

    assetText.setOrigin(0.5, 0.5);
    
    this.load.on('progress', function (value) {
        progressBar.clear();
        progressBar.fillStyle(0x000000, 1);
        progressBar.fillRect(217, 272, 106 * value, 6);
    });
    
    this.load.on('fileprogress', (file) => {
      this.loadcnt++;
      //console.log("max="+this.loadcnt)
      if(GameConfig.debug)
        assetText.setText('Loading asset: ' + file.key);
        else
        assetText.setText('Loading asset: ' + Math.ceil(this.loadcnt*100/this.loadmax) + '%');
    });

    this.load.on('complete', function () {
        progressBar.destroy();
        progressBox.destroy();
        assetText.destroy();
    });
    // PC or SmartPhone
    var dev = getDevice();
    if(dev == 'sp' || dev == 'iPad'){
      var assetpath = 'assets_mb';
    }else{
      var assetpath = 'assets';
    }
    //game manual
    this.load.image('img_howto',assetpath + '/img/parts/manual.png')
    // Background
    this.load.image('img_title_bg', assetpath + '/img/parts/title_back.png');

    // Background
    this.load.image('img_background', assetpath + '/img/parts/background.png');
    
    //button etc
    this.load.image('img_btn_hint', assetpath + '/img/parts/button_hint.png');
    this.load.image('img_btn_giveup', assetpath + '/img/parts/button_giveup.png');
    this.load.image('img_btn_ok', assetpath + '/img/parts/button_ok.png');
    this.load.image('img_btn_replay', assetpath + '/img/parts/button_replay.png');
    this.load.image('img_btn_restart', assetpath + '/img/parts/button_restart.png');
    this.load.image('img_btn_tojiru', assetpath + '/img/parts/button_tojiru.png');
    this.load.image('img_clear_back', assetpath + '/img/parts/clear_back.png');
    this.load.image('img_titlehe', assetpath + '/img/parts/button_titlehe.png');
    this.load.image('img_clear', assetpath + '/img/parts/clear.png');
    //this.load.image('img_crown', assetpath + '/img/parts/oukan.png');
    this.load.image('img_treasure1', assetpath + '/img/parts/treasure1.png');
    this.load.image('img_treasure2', assetpath + '/img/parts/treasure2.png');
    this.load.image('img_clear_time', assetpath + '/img/parts/clear_time.png');
    this.load.image('img_manual', assetpath + '/img/parts/setsumeisyo.png');
    this.load.image('img_back', assetpath + '/img/parts/back.png');
    this.load.image('img_time_plus', assetpath + '/img/parts/time_plus.png');
    this.load.image('img_time_plus_back', assetpath + '/img/parts/time_plus_back.png');
    
    this.load.image('img_btn_home', assetpath + '/img/parts/button_home.png');
    this.load.image('img_home', assetpath + '/img/parts/home.png');
    this.load.image('img_restart', assetpath + '/img/parts/restart.png');
    this.load.image('img_se_on', assetpath + '/img/parts/se_on.png');
    this.load.image('img_se_off', assetpath + '/img/parts/se_off.png');
    this.load.image('img_stop', assetpath + '/img/parts/stop.png');
    this.load.image('img_time', assetpath + '/img/parts/time_frame.png');
   
    //this.load.image('img_num',assetpath + '/img/parts/time_number.png');
    this.load.spritesheet('img_num', 
    assetpath + '/img/parts/time_number.png',
    { frameWidth: 16, frameHeight: 23 }
    );
    this.load.spritesheet('img_rnum', 
    assetpath + '/img/parts/remain_number.png',
    { frameWidth: 22, frameHeight: 27 }
    );
    this.load.spritesheet('img_pnum', 
    assetpath + '/img/parts/number.png',
    { frameWidth: 90, frameHeight: 90 ,
      spacing: 1,
      //margin: 1,
    }
    );
    this.load.spritesheet('img_hnum', 
    assetpath + '/img/parts/button_hint_num.png',
    { frameWidth: 23, frameHeight: 27 
      //
      //margin: 1,
    }
    );
    this.load.image('remain_frame', assetpath + '/img/parts/remaini_frame.png');

    this.load.image('easy_start', assetpath + '/img/parts/easy_start.png');
    this.load.image('normal_start', assetpath + '/img/parts/normal_start.png');
    this.load.image('hard_start', assetpath + '/img/parts/hard_start.png');
    this.load.image('img_start', assetpath + '/img/parts/button_start.png');
    this.load.image('img_help', assetpath + '/img/parts/button_asobikata.png');
    this.load.image('img_title', assetpath + '/img/parts/title_logo.png');
    //this.load.image('img_joker', assetpath + '/img/parts/title_joker.png');
    this.load.image('img_fukurou', assetpath + '/img/parts/fukurou.png');
    

    //this.load.image('img_over', assetpath + '/img/parts/gameover.png');
    this.load.image('img_tezumari', assetpath + '/img/parts/tezumari.png');

    //Sound
    /*
    this.load.audio('se_cursor7', assetpath + '/sound/cursor7.mp3');
    this.load.audio('se_cancel6', assetpath + '/sound/cancel6.mp3');
    this.load.audio('se_decision3', assetpath + '/sound/decision3.mp3');
    this.load.audio('se_over', assetpath + '/sound/tin1.mp3');
    this.load.audio('se_decision5', assetpath + '/sound/decision5.mp3');  
    this.load.audio('se_decision8', assetpath + '/sound/decision8.mp3');
    this.load.audio('se_cursor10', assetpath + '/sound/cursor10.mp3');
    */
   this.load.audio('se_decision3', assetpath + '/sound/button_normal.mp3');
   this.load.audio('se_start', assetpath + '/sound/button_start.mp3');
   this.load.audio('se_erase', assetpath + '/sound/erase.mp3');
   this.load.audio('se_over', assetpath + '/sound/gameclear.mp3');
   this.load.audio('se_undo', assetpath + '/sound/stepback.mp3');
  }
    
  // Create
  create () {
    this.scene.start('MenuState');
  }
}